import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SettingConstants } from 'src/core/constants/setting-constant';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';

@Component({
  selector: 'ca-interaction-management-settings',
  templateUrl: './interaction-management-settings.component.html',
  styleUrl: './interaction-management-settings.component.scss',
  standalone: false,
})
export class InteractionManagementSettingsComponent {
  form: FormGroup;

  private readonly enabled = SettingConstants.InteractionManagementEnabled;

  constructor(
    private config: ConfigStateService,
    private fb: FormBuilder,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private localizationService: LocalizationService
  ) {
    this.form = fb.group({
      enableUserGroupManagement: [JSON.parse(this.config.getSetting(this.enabled).toLowerCase())],
    });
    this.form
      .get('enableUserGroupManagement')
      .patchValue(JSON.parse(this.config.getSetting(this.enabled).toLowerCase()));
  }

  ngOnInit(): void {}

  onSubmitForm() {
    if (!this.form.valid) {
      return;
    }

    const settings: ConfigurationSettingsDto[] = [];

    settings.push({
      settingName: this.enabled,
      settingValue: this.form.get('enableUserGroupManagement').value.toString(),
    });
    const previousFormValue = this.form.getRawValue();
    this.settingService.saveSetting(settings).subscribe({
      next: () => {
        this.toastr.success(
          this.localizationService.instant('AbpSettingManagement::SavedSuccessfully')
        );
      },
      error: err => {
        const errorMessage =
          err?.error?.error?.message ||
          err?.error?.message ||
          this.localizationService.instant('AbpUi::UnexpectedError');

        this.toastr.error(errorMessage);

        this.form
          .get('enableUserGroupManagement')!
          .setValue(previousFormValue, { emitEvent: false });
      },
    });
  }
}
